var anObject = require('../internals/an-object');

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/iterator-close.js